<template>
    <div class="animated fadeIn">        
        <b-card>
            <div slot="header">
                Material/Service Purchase Request - View
                <div class="card-header-actions">
                  <b-button variant="primary mr-1" @click="print()"><i class="fa fa-print"></i> Print</b-button>
                  <button class="btn btn-danger mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
                </div>
            </div>
            <b-form>
              <b-row>
                <b-col lg="8">
                    <b-row>
                        <b-col lg="6">
                            <b-input-group>
                                <b-input-group-prepend><label>Purchase Req. No.</label></b-input-group-prepend>
                                <b-form-input v-model="model.requestno" disabled></b-form-input>
                            </b-input-group>
                        </b-col>
                         <b-col lg="6">                            
                            <b-input-group>
                                <b-input-group-prepend><label>Request Date</label></b-input-group-prepend>
                                <b-form-input v-model="model.requestdate" type="date" disabled></b-form-input>                                        
                            </b-input-group>
                        </b-col>
                    </b-row >    
                    <b-row>
                        <b-col>
                            <b-input-group >
                                <b-input-group-prepend><label>Requisition(MR) No.</label></b-input-group-prepend>
                                <b-form-input readonly v-model="model.mrequestno"></b-form-input>
                            </b-input-group>
                        </b-col>
                        <b-col lg="6">                            
                            <b-input-group >
                            <b-input-group-prepend><label>Request Type</label></b-input-group-prepend>
                                <b-form-input :value="model.jasa?'Service Request':'Material Request'" readonly></b-form-input>
                                <b-form-checkbox :value="1" :unchecked-value="0" v-model="model.barter" class="mt-1" disabled>BARTER</b-form-checkbox>
                            </b-input-group>
                        </b-col>                        
                    </b-row >    
                    <b-input-group>
                        <b-input-group-prepend><label>Internal Budget</label></b-input-group-prepend>
                        <b-form-input v-model="model.budgetinfo" readonly v-b-tooltip.hover :title="model.budgetname"></b-form-input>
                    </b-input-group>

                    <b-row align-h="between">
                        <b-col lg="6">                            
                            <b-input-group >
                                <b-input-group-prepend><label>{{labelExpected}}</label></b-input-group-prepend>
                                <b-form-input v-model="model.expectreceipt" type="date" disabled></b-form-input>                                        
                            </b-input-group>
                        </b-col>
                        <b-col lg="6">                            
                            <b-input-group v-show="(model.jasa)">
                                <b-input-group-prepend><label>Expect.Service Finish</label></b-input-group-prepend>
                                <b-form-input v-model="model.jasafinish" type="date" disabled></b-form-input>                                        
                            </b-input-group>
                        </b-col>
                    </b-row>                      
                    <b-row align-h="between">
                        <b-col lg="6">                            
                            <b-input-group >
                                <b-input-group-prepend><label>{{labelLocation}}</label></b-input-group-prepend>
                                <b-form-input v-model="model.locationdeliv"  disabled></b-form-input>
                            </b-input-group>
                        </b-col>
                        <b-col lg="6">                            
                            <b-input-group >
                                <b-input-group-prepend><label>Note/Remark</label></b-input-group-prepend>
                                <b-form-input v-model="model.remark" disabled></b-form-input>
                            </b-input-group>
                        </b-col>
                    </b-row>                      
                </b-col>
                <b-col md="4">
                    <v-dim :model="model" :key="updateDimHdr" ></v-dim>
                    <b-input-group >
                        <b-input-group-prepend><label>Directur MR/User</label></b-input-group-prepend>
                        <b-form-input readonly v-model="model.nextwf_crewname" disabled></b-form-input>
                    </b-input-group>

                </b-col>
              </b-row>
              <b-card no-body class="mb-1">
                <b-table
                    class="mb-0"
                    ref="tblOrdLines"
                    outlined
                    striped hover small
                    style="font-size:smaller;"
                    :items="ordLines.items"
                    :fields="ordLines.fields"
                    :current-page="ordLines.page"
                    :per-page="ordLines.limit"
                    show-empty
                    >
                        <template v-slot:cell(index)="data">
                        {{data.index + 1}}
                        </template>
                        <template v-slot:cell(partnumber)="data">
                            {{data.item.partnumber}} | {{data.item.itemname}}
                        </template>
                        <template v-slot:cell(quantity)="data">
                            {{data.item.quantity}} {{data.item.unitsize}}
                        </template>
                        <template v-slot:cell(nilai)="data">
                        {{data.item.nilai|numFormat}}
                        </template>
                        <template v-slot:cell(action)="data">
                            <div class="text-center">
                            <a href="javascript:void(0)" @click="editOrdLines(data.item,data.toggleDetails)">
                                <i class="fa fa-pencil"></i>
                            </a>
                            </div>
                        </template>
                    <template v-slot:row-details="row">
                        <b-card class="row-details-form">
                        <b-row  align-h="center">
                            <b-col lg="6" xl="6" class="pl-0">
                                <b-input-group>
                                    <b-input-group-prepend><label>Master Item</label></b-input-group-prepend>
                                    <b-form-input readonly v-model="ordLinesObj.iteminfo" ></b-form-input>
                                </b-input-group>
                                <b-input-group>
                                    <b-input-group-prepend><label>Description</label></b-input-group-prepend>
                                    <b-form-textarea :rows="3" :max-rows="10" v-model="ordLinesObj.description" disabled ></b-form-textarea>
                                </b-input-group>
                                <b-form-row>
                                <b-col md="6">                            
                                    <b-input-group>
                                        <b-input-group-prepend><label>Quantity</label></b-input-group-prepend>
                                        <b-form-input v-model="ordLinesObj.quantity" type="number" v-bind:min="1" disabled></b-form-input>
                                    </b-input-group>
                                </b-col>
                                <b-col md="6">                            
                                    <b-input-group>
                                        <b-input-group-prepend><label style="width:70px; text-align:right;">Unit Size</label></b-input-group-prepend>
                                        <b-form-input readonly v-model="ordLinesObj.unitsize"></b-form-input>
                                    </b-input-group>
                                </b-col>
                                </b-form-row >   
                                <b-form-row>
                                    <b-col lg="9" xl="6">                            
                                        <b-input-group>
                                            <b-input-group-prepend><span class="p-2">Estimate Unit price</span></b-input-group-prepend>
                                            <b-input-group-prepend>
                                            <span class="input-group-text">{{model.matauang}}</span>
                                            </b-input-group-prepend>
                                            <my-number class="form-control text-right" v-model="ordLinesObj.unitprice" :precision="2" disabled></my-number>
                                        </b-input-group>
                                    </b-col>
                                </b-form-row >                      

                            </b-col>
                            <b-col lg="6" xl="5">
                                <v-dim :model="ordLinesObj" :key="updateDimDtl"></v-dim>
                            </b-col>
                        </b-row>
                        <b-row class="justify-content-center mt-1">
                            <div style="width:400px;">
                                <b-input-group >
                                    <b-input-group-append>
                                        <b-button class="btn btn-warning ml-1" @click="row.toggleDetails">Hide Detail</b-button>
                                    </b-input-group-append>
                                </b-input-group>
                            </div>
                        </b-row>
                        </b-card>
                    </template>  
                    <template v-slot:cell(empty)="scope">
                        <h4>{{ scope.emptyText }}</h4>
                    </template>
                    <template v-slot:cell(emptyfiltered)="scope">
                        <h4>{{ scope.emptyFilteredText }}</h4>
                    </template>         
                </b-table>
                <b-row class="mt-1">
                    <b-col cols="6">
                        <b-row>
                            <div class="ml-3">
                                Showing {{((ordLines.page - 1) * ordLines.limit + 1)}}
                                to <span v-if="((ordLines.page * ordLines.limit)>ordLines.total)">{{ordLines.total}}</span>
                                    <span v-else>{{ordLines.page * ordLines.limit}}</span>
                                <strong> of {{ordLines.total}} entries </strong>
                            </div>    
                        </b-row>                    
                    </b-col>
                    <b-col cols="6">
                        <div style="float:right;">
                            <b-pagination 
                                align="right" size="sm"
                                :total-rows="ordLines.total"
                                :per-page="ordLines.limit"
                                v-model="ordLines.page"
                            ></b-pagination>
                        </div>
                        <div style="width:400px; text-align:right;float:right;padding-top:2px;">
                            <span class="mr-1">limit per page :</span> 
                            <input type="number" style="width:60px;" v-model="ordLines.limit"/>
                        </div>
                    </b-col>

                </b-row>
              </b-card>    
              <b-row align-h="between" class="mt-1">
                    <b-col lg="8" xl="7">
                        <b-input-group >
                            <b-input-group-prepend><label style="width: 170px !important;">Sugested Supplier/Vendor</label></b-input-group-prepend>
                            <b-form-input readonly v-model="model.vendorinfo"></b-form-input>
                        </b-input-group>
                    </b-col>
                    <b-col lg="4">
                        <div class="text-right">
                            <b-input-group >
                                <b-input-group-prepend><label style="text-align: left; width:120px; padding-left:16px;">Estimated Total</label></b-input-group-prepend>
                                <b-input-group-prepend>
                                <b-form-select  v-model="model.matauang" :plain="true" :options="currency" ></b-form-select>
                                </b-input-group-prepend>
                                <my-number class="form-control text-right" v-model="model.ttlnetto" :precision="2" disabled></my-number>
                            </b-input-group>
                            <b-row style="text-align: left !important;">
                                <b-col >
                                        <b-form-checkbox  v-model="model.chargeable" value=1 unchecked-value=0 style="margin-left:120px;" disabled>
                                        Chargeable to Customer
                                        </b-form-checkbox>
                                </b-col>
                            </b-row>
                        </div>
                    </b-col>
              </b-row>
            </b-form>
            <b-row class="justify-content-center mb-2">
                <div style="width:450px;">
                    <b-input-group >
                        <b-input-group-append>
                            <button  class="btn btn-primary mr-1" @click="print()"><i class="fa fa-print"></i> Print</button>
                        </b-input-group-append>
                        <b-input-group-append>
                            <button class="btn btn-danger mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
                        </b-input-group-append>
                    </b-input-group>
                </div>
            </b-row>

        </b-card>
        <b-modal v-model="showReport" size="xl" scrollable title="Preview as PDF" ok-only>
            <iframe v-if="reportUrl" :src="reportUrl" frameborder="0"></iframe>
        </b-modal>
        <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       
    </div>
</template>
<style lang="scss">
    .input-group {
        padding-bottom:2px;
        .input-group-prepend {
            label {
                padding-top: 5px;
                padding-right: 5px;
                width: 130px;
            }
        }
    }
    .form-group {
        margin-bottom:2px;
        .input-group {
            padding-bottom:0;
        }
    }
    .row-details-form {
        .input-group-prepend {
            label {
                padding-top: 5px;
                padding-right: 5px;
                width: 80px;
            }
        }
        label {
        text-align: right !important;
        }
        legend {
        text-align: right !important;;
        }
    }
</style>

<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import toastr from "mini-toastr";
import moment from 'moment';
import myNumber from "../components/my-number";
import vDim from "./lookup/dim";
import pr from "../apis/logistic_pr";
toastr.init();

export default {   
  components: { Loading, myNumber, vDim},
  data() {
    return {
      inputBerlanjut: 1,
      inputLineBerlanjut: 1,
      isLoading: false,
      showReport:false,
      reportUrl: null,
        isEdit:false,
        updateDimHdr:false,
        updateDimDtl:true,
        uanguser: this.$store.state.user.matauang,
        currency:[{value:'IDR',text:'IDR'}],
        linetypes : [{ value: 1, text: 'Master Item ' },{ value: 3, text: 'GL Account' }],
        jasaMaterial : [{ value: 1, text: 'Service Request' }, { value: 0, text: 'Material Request' }],
        model:{jasa:0, matauang:this.$store.state.user.matauang, requestno:'', locationdeliv:this.$store.state.user.compaddr,ttlnetto:0, requestdate: moment().format('YYYY-MM-DD')},
        labelLocation:'Delivery Location',
        labelExpected:'Expected Delivery',
        ordLines: {
            items: [],
            selected:{},
            fields: [
                {key: 'index', label: 'No.' ,thStyle: "width:40px"},
                {
                    key: "partnumber",
                    label: "Master Item",
                    thStyle: "width:240px",
                },
                {
                    key: "description",
                    label: "Description",
                    thStyle: "width:240px",
                },
                {
                    key: "quantity",
                    label: "Quantity",
                    thStyle: "width:100px",
                    thClass: "text-center",
                    tdClass: "text-center"
                },
                {
                    key: "nilai",
                    label: "Estimate Price",
                    thStyle: "width:110px",
                    thClass: "text-right",
                    tdClass: "text-right"
                },
                {
                    key: "actionStatus",
                    label: "Status",
                },
                {
                    key: "action",
                    label: "Action",
                    thStyle: "width:40px",
                    thClass: "text-center",
                },
            ],
            page: 1,
            limit: 20,
            total: 0,
        },
        ordLinesObj:{linetype:1,itemno:'', description:'', quantity:0, unitzise:''},

    };
},
  computed: {
    dimension(){
      return this.$store.state.dimension;
    },
  },
  created: async function(){
    if (this.$route.params.requestkey)  {          
          try {
            this.isEdit = true;
            const data = await pr.detail(this.$route.params);  
            const row = data[0][0];
            row.requestdate = row.requestdate ? moment(row.requestdate).format('YYYY-MM-DD') : '';
            row.expectreceipt = row.expectreceipt ? moment(row.expectreceipt).format('YYYY-MM-DD') : '';
            for (var key in row) {
                this.model[key] = row[key];
            }
            this.ordLines.items = data[1];
            this.model.terms = data[2];
            this.ordLines.total=this.ordLines.items.length;
            this.calcTotalDtlOrder();
            this.$forceUpdate();                
            toastr.clear;
          } catch (error) {
                console.log('error : ', error);
                toastr.error(JSON.stringify(error), "ERROR MESSAGE");                              
          }
      } 
  },
  methods: {
    closeOrdLines: function(){
        const opened= this.ordLines.items.find( r=> r._showDetails==true);
        if (opened) opened._showDetails=false;
    },
    editOrdLines : function (obj,callback) {
        this.closeOrdLines();
        this.ordLines.selected = obj;
        for (var key in this.ordLinesObj) {
            this.ordLinesObj[key] = '';
        }
        for (var key in obj) {
            this.ordLinesObj[key] = obj[key];
        }
        this.dimension.forEach((dim) => {
            if (obj[dim.value]) {
                this.ordLinesObj[dim.value] = obj[dim.value];
                this.ordLinesObj[`${dim.value}Txt`] = obj[`${dim.value}Txt`];
                this.ordLinesObj[`${dim.value}Info`] = obj[dim.value] + ' | '+ obj[`${dim.value}Txt`];
            }
        });
        this.inputLineBerlanjut=0;
        callback();
    },
    print: async function()
    {
      if (this.model.requestkey) {
          try {
                this.showReport=true;
              this.model.typePR = 'open';
              this.reportUrl= await pr.print(this.model);

          } catch (error) {
              if (error.message) {
                  toastr.error(error.message);
              } else {
                  toastr.error(JSON.stringify(error));
              }
          }
        } else {
            toastr.warn('Please select a row that want to be Printed!');
        }
    },

    calcTotalDtlOrder: function () {
        let ttlnetto = 0;
        this.ordLines.items.forEach((trx)=> {
            if (trx.itemno) {
                ttlnetto += (trx.nilai || 0);
            }
        });
        this.model.ttlnetto = ttlnetto;
    },

    close(){
      if ((this.$store.state.prevRoute.name)) {
        router.push({name:this.$store.state.prevRoute.name});
      } else {
          router.push({name:"app.modules"});
      }
    }
  }
};
</script>
